$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/baseup/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

	$('.header_menu_content a').on('click', function () {
		body.removeClass('menu_open');
		// return false;
	});

    //閉じるボタン
    // $('.header_ac_close').on('click', function () {
    //     body.removeClass('menu_open');
    //     body.removeClass('search_open');
    // });

    //メニュー名以外の部分をクリックで閉じる
    $('.layer').on('click', function () {
        body.removeClass('menu_open');
        // body.removeClass('search_open');
    });

	//ヘッダードロップダウンメニュー
    $('.header_ac_trigger').on('click', function () {
        $(this).toggleClass('on');
        // $(this).parents(".header_ac").toggleClass('on');
        $(this).next().toggleClass('on');
        // $(".header_ac_trigger").not(this).removeClass("on");
        // $(".header_ac_trigger").not(this).next().removeClass("on");
    });

	//アコーディオン
	$('.ac_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".ac_content").slideToggle();
	});

	//動画ポップアップ
    $('.youtubeModal').modalVideo({channel: 'youtube'});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//タブ切り替え
    $(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parents().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parents().next().find(".tab_panel").eq($th).addClass("active");
	});

	//トップページのみ
	if($('.home').length){

		// メインビジュアルが隠れたら
		var scroll;
		var objH = $('.home_mv').outerHeight();
		var objTop = $('.home_mv').offset().top;
		var objBottom = objTop + objH;
		$(window).on('scroll', function(){
		  	scroll = $(window).scrollTop();
		  	if(scroll >= objBottom){
		    	// 特定の要素を超えた
		    	// console.log("超えた");
				body.addClass("mvOut");
		  	} else {
				// 特定の要素を超えていない
				// console.log("超えていない");
				body.removeClass('mvOut');
			}
		});

	}

	//トップ MVスライド
	const home_mv_swiper = new Swiper('.home_mv_swiper', {
		allowTouchMove: false,
		loop: true,
		effect: 'fade',
		fadeEffect: {
    		crossFade: true,
  		},
		speed: 2000,
		autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        on: {
	    	afterInit: function(home_mv_swiper) {
	      		home_mv_swiper.autoplay.stop();
	      		setTimeout(function () {
	        		home_mv_swiper.autoplay.start();
	      		}, 2000);
	    	}
	  	}
    });

	//メッセージ開閉
    var min_height = 200; //initial height.
    var ani_duration = 200;
    $('.messageBlock_more').click(function(){
        var messageBlock_content = $(this).prev(".messageBlock_content");
        var original_height = messageBlock_content.css({height : 'auto'}).height();
        if(messageBlock_content.hasClass('open')){
          //--CLOSE--
          var scroll_offset = $("html,body").scrollTop() - original_height + min_height;
          $("html,body").animate({ scrollTop: scroll_offset }, ani_duration);
          messageBlock_content.animate({height:min_height}, ani_duration, function(){});
          messageBlock_content.removeClass('open');
          $(this).removeClass('open');
          $(this).children('span').html('続きをみる');
        }else{
          //--OPEN--
          messageBlock_content.height(min_height).animate({height:original_height},ani_duration, function(){
            messageBlock_content.height('auto').addClass('open');
          });
          $(this).addClass('open');
          $(this).children('span').html('閉じる');
        }
    });

});